import bgFundoLive from '../../assets/bg-fundo-live-revalida.png';
import { Box, Container, Grid, Typography } from '@mui/material';
import logoArena from '../../assets/logo-arena-default-2025-1.svg';

export default function FirstSectionLiveArena251() {
	return (
		<Grid
			xs={12}
			sx={{
				backgroundImage: `url(${bgFundoLive})`,
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			}}
		>
			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className={'revalida'}
			>
				<Grid
					container
					className={'section'}
					sx={{
						paddingY: '40px',
						marginTop: { xs: 8, md: '20px' },
						gap: { xs: 4, md: 0 },
						flexDirection: { xs: 'column-reverse', md: 'row' },
						justifyContent: 'space-between',
					}}
				>
					<Grid
						item
						container
						xs={12}
						md={6.5}
					>
						<Box
							sx={{
								paddingX: '20px',
								paddingY: '8px',
								borderRadius: '8px',
								marginBottom: '16px',
							}}
							className={'background-revalida-ldl'}
						>
							<Typography
								variant={'h6'}
								fontFamily={'Poppins'}
								color={'#FFFFFF'}
								fontSize={'24px'}
								fontWeight={600}
								lineHeight={1}
							>
								LIVE{' '}
							</Typography>
						</Box>
						<Typography
							variant={'h1'}
							fontFamily={'Poppins'}
							color={'#FFFFFF'}
							fontSize={{ xs: '28px', md: '48px' }}
							fontWeight={600}
							lineHeight={1}
						>
							DESAFIO DOS IMBATÍVEIS HARDWORK MEDICINA
						</Typography>

						<Box
							className={'background-revalida-ldl'}
							sx={{
								marginTop: '32px',
								marginBottom: '48px',
								padding: '1px',
								borderRadius: '8px',
							}}
						>
							<Box
								sx={{
									backgroundColor: 'black',
									paddingX: '40px',
									paddingY: '8px',
									borderRadius: '8px',
									boxShadow: '3px 3px 20.9px 0px #09D686',
								}}
							>
								<Typography
									variant={'h6'}
									textAlign={'center'}
									fontFamily={'Poppins'}
									color={'#FFFFFF'}
									fontSize={{ xs: '14px', md: '16px' }}
									fontWeight={700}
									lineHeight={1}
								>
									VAMOS JUNTOS FAZER UMA ESTAÇÃO INTERATIVA NO MODELO INEP
								</Typography>
							</Box>
						</Box>
						<Typography
							variant={'h6'}
							fontFamily={'Poppins'}
							color={'#CCCCCC'}
							fontSize={{ xs: '16px', md: '20px' }}
							fontWeight={400}
							lineHeight={1.2}
						>
							Participe do desafio dos imbatíveis e vamos juntos dissecar uma estação do INEP, passando
							por tudo que é importante no checklist, com dicas preciosas para a preparação da prova
							prática do Revalida.
							<br />
							<br />
							Conheça também o Arena Hardwork Imbatível e se prepare com quem domina a prova do INEP desde
							a primeira fase.
						</Typography>
						<Typography
							variant={'h4'}
							fontFamily={'Manrope'}
							color={'#F1F1F1'}
							fontSize={{ xs: '24px', md: '32px' }}
							fontWeight={800}
							lineHeight={1.2}
							sx={{ paddingTop: '16px' }}
						>
							08 ABR • A partir das 20H25
						</Typography>
					</Grid>
					<Grid
						container
						item
						xs={12}
						md={5}
						justifyContent={'center'}
						alignItems={'center'}
					>
						<Box
							sx={{
								width: { xs: '70%', md: '100%' },
							}}
						>
							<img
								src={logoArena}
								alt={'logo arena'}
							/>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</Grid>
	);
}
